module.exports = __webpack_public_path__ + "img/logo2ddd.a80dcc29.png";